import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

export const CLASS_NAME_FOR_HOVER_TARGET = 'hoverActionButton-target';
export const CLASS_NAME_FOR_HOVER_BUTTON = 'hoverActionButton-button';

interface HoverActionButtonProps {
  ariaLabel: string;
  icon: BenchlingIconName;
  onClick: (event: ElementMouseEvent | ElementKeyboardEvent) => void;
  className?: string;
}

export default function HoverActionButton(props: HoverActionButtonProps): JSX.Element {
  return (
    <div
      aria-label={props.ariaLabel}
      className={classNames(CLASS_NAME_FOR_HOVER_BUTTON, 'invisible', props.className)}
      {...getActionButtonRoleProps({onPress: props.onClick})}
    >
      <BenchlingIcon icon={props.icon} />
    </div>
  );
}
